/* snippet: https://medium.com/@Elijah_Meeks/interactive-applications-with-react-d3-f76f7b3ebc71 */
import React from "react";
import { DefaultPlayer as Video } from "react-html5video";
import "react-html5video/dist/styles.css";
import "./styles.scss";

export class VideoPlayer extends React.Component {
  constructor() {
    super();

    this.isMobile = window.innerWidth < 600;
    this.isIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    this.state = {
      isPlaying: false,
      initialPlay: false
    };
  }

  render() {
    return (
      <div
        className={this.state.isPlaying ? "videoplayer" : "videoplayer paused"}
      >
        <Video
          playsInline
          controls={this.isIOS ? [] : this.isMobile ? [] : []}
          poster={this.props.poster}
          onPlay={() => {
            /* taking all the supported HTML5 video attributes except for controls: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/video#Events */
            this.setState({ isPlaying: true });
            if (!this.state.initialPlay) {
              this.setState({ initialPlay: true });
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: "Interactions",
                event_action: "click",
                event_label: "PlayVideo: " + this.props.trackingID
              });
            }
          }}
          onPause={() => {
            /* taking all the supported HTML5 video attributes except for controls: https://developer.mozilla.org/en-US/docs/Web/HTML/Element/video#Events */
            this.setState({ isPlaying: false });
          }}
        >
          {this.props.webm && !this.isMobile && (
            <source src={this.props.webm} type="video/webm" />
          )}
          {this.props.ogv && !this.isMobile && (
            <source src={this.props.ogv} type="video/ogg" />
          )}
          {this.props.mp4 && !this.isMobile && (
            <source src={this.props.mp4} type="video/mp4" />
          )}

          {this.props.webmMobile && this.isMobile && (
            <source src={this.props.webmMobile} type="video/webm" />
          )}
          {this.props.ogvMobile && this.isMobile && (
            <source src={this.props.ogvMobile} type="video/ogg" />
          )}
          {this.props.mp4Mobile && this.isMobile && (
            <source src={this.props.mp4Mobile} type="video/mp4" />
          )}
        </Video>
      </div>
    );
  }
}
